module.exports = "<my-commande-edit-form my-commande=\"$$commande.data.myCommande\"\n  my-wagons=\"$$commande.data.myWagons\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-commande-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/commande/templates/edit.html
// module id = 1555
// module chunks = 0